import { render, staticRenderFns } from "./AssignorgroupAdd.vue?vue&type=template&id=65cfbff7&"
import script from "./AssignorgroupAdd.vue?vue&type=script&lang=js&"
export * from "./AssignorgroupAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports